import Cookie from "./cookie";
import Common from "./common";

const IMG_CHECK_OFF = "/images/new/btn_check_off.png";
const IMG_CHECK_ON = "/images/new/btn_check_on.png";

// 변수 정의
let $myInfo = $("#myinfo");
let $realName = $("#realname");
let $userId = $("#user_id");
let $idCheckBtn = $("#idcheck");
let $userEmail = $("#user_email");
let $joinBoxTxtTr = $("#li_join_mail"); // 메일인증 문구 tr
let $joinBoxPwTr = $("#join_pw_area"); // 비밀번호 입력 tr

let $provision1 = $("#provision_1");
let $provision2 = $("#provision_2");
let $provisionAll = $("#provision_all");

var $password = $("#password");
var $passwordConfirm = $("#password_confirm");

let $joinBtn = $("#btn_join");

const $joinBtnViews = $(".join_btn_veiw"); // 내용보기 버튼... view (X) ->  오타조심
const $termsBoxes = $(".terms_box");

const JoinMemberCheck = {
    provision_1: false,
    provision_2: false,
    provision_all: false,
    realnameck: false,
    check_id: false,
    check_email: false,
    check_pw: false,
    check_pw_confirm: false,
    nicknameck: false
};

$termsBoxes.hide();

$joinBtnViews.on("click", e => {
    e.preventDefault();
    const $currentTarget = $(e.currentTarget);
    $currentTarget
        .closest("li")
        .find(".terms_box")
        .slideToggle("800");
});

const urlParams = Common.getURLParameters(location.href);

function drawBorderBottom() {
    $(".join_info_area").css("border-bottom", "1px solid #f0f0f0");
}

function changeJoinMode() {
    if (urlParams["snsType"]) {
        drawBorderBottom();
        $(".the_hide_thing").hide();
        switch (urlParams["snsType"]) {
            // 아이디입력 숨김
            // 이름, 이메일 보이기
            // 비밀번호, 비밀번호확인 숨김
            case "naver":
                $userId.closest("li").hide();
                $joinBoxTxtTr.hide();
                $joinBoxPwTr.hide();
                break;
            case "kakao":
                $userId.closest("li").hide();
                $joinBoxTxtTr.hide();
                $joinBoxPwTr.hide();
                break;
            case "facebook":
                $userId.closest("li").hide();
                $joinBoxTxtTr.hide();
                $joinBoxPwTr.hide();
                break;
            default:
                break;
        }
        return "sns";
    } else {
        return "wagle";
    }
}

// 약관동의 버튼을 클릭한다.
// 둘다 체크되면 all 도 체크, all 버튼 데이터 true
// 아니면 체크 해제, all 버튼 데이터 false

// 개인정보 버튼을 클릭한다.
// 둘다 체크되면 all도 체크, all 버튼 데이터 true
// 아니면 체크 해제, all 버튼 데이터 false
function checkProvision(e, provisionName, iconId) {
    e.preventDefault();
    if (provisionName !== "provision_all") {
        JoinMemberCheck[provisionName]
            ? $(iconId).attr("src", IMG_CHECK_OFF)
            : $(iconId).attr("src", IMG_CHECK_ON);
        JoinMemberCheck[provisionName] = !JoinMemberCheck[provisionName];
    }
    if (provisionName === "provision_all") {
        if (!JoinMemberCheck[provisionName]) {
            $("#icon_1").attr("src", IMG_CHECK_ON);
            $("#icon_2").attr("src", IMG_CHECK_ON);
            JoinMemberCheck["provision_1"] = true;
            JoinMemberCheck["provision_2"] = true;
        } else {
            $("#icon_1").attr("src", IMG_CHECK_OFF);
            $("#icon_2").attr("src", IMG_CHECK_OFF);
            JoinMemberCheck["provision_1"] = false;
            JoinMemberCheck["provision_2"] = false;
        }
    }
    if (JoinMemberCheck["provision_1"] && JoinMemberCheck["provision_2"]) {
        $("#icon_all").attr("src", IMG_CHECK_ON);
        JoinMemberCheck["provision_all"] = true;
        $(".pro_caution").attr("style", "display:none");
    } else {
        $("#icon_all").attr("src", IMG_CHECK_OFF);
        JoinMemberCheck["provision_all"] = false;
    }
};

function addProvisionCheckEvt () {
    $provision1.on("click", e => {
        checkProvision(e, "provision_1", "#icon_1");
    });
    $provision2.on("click", e => {
        checkProvision(e, "provision_2", "#icon_2");
    });
    $provisionAll.on("click", e => {
        checkProvision(e, "provision_all");
    });
};

const SnsJoinProc = (function() {
    let snsObj = JSON.parse(decodeURIComponent(localStorage.getItem("snsObj")));

    function submitCheck() {
        // 약관 동의 둘 다 체크 되지않으면
        if (!JoinMemberCheck["provision_all"]) {
            $(".pro_caution").attr("style", "display:inline");
            snsObj.confirmed_eula = "N";
            return;
        } else {
            snsObj.confirmed_eula = "Y";
        }

        if (Common.isEmpty($realName.val())) {
            alert("이름을 입력해 주세요.");
            $realName.focus();
            return false;
        }
        return true;
    };

    function init() {
        $realName.on("blur", e => {
            snsObj["realname"] = e.currentTarget.value;
        });
        if (snsObj["realname"] !== "") {
            $realName.val(snsObj["realname"]);
            $realName.prop("disabled", true);
            $realName.addClass("readonly");
        }
        if (snsObj["user_email"] !== "") {
            $userEmail.val(snsObj["user_email"]);
            $userEmail.prop("disabled", true);
            $userEmail.addClass("readonly");
        }
        $joinBtn.on("click", function(e) {
            e.preventDefault();
            if (submitCheck()) {
                $.ajax("./_proc/sns_join.php", {
                    type: "POST",
                    data: snsObj
                }).then(
                    function(res) {
                        localStorage.removeItem("snsObj");

                        res = JSON.parse(res);
                        if (res["success"]) {
                            // location.replace(res["redirect_url"]);
                            location.href = "/member/join_3.htm?action=end";
                        } else {
                            alert(res["message"]);
                        }
                    },
                    function(err) {
                        alert(err);
                    }
                );
            }
        });
    };

    return {
        init
    };
})();

const JoinProvision = (function() {
    const JoinMember = {
        user_id: "",
        user_email: "",
        realname: "",
        password: "",
        password_confirm: "",
        confirmed_info_mail: "N",
        confirmed_eula: "N",
        commitType: null
    };

    function submitCheck() {
        // 약관 동의 둘 다 체크 되지않으면
        if (!JoinMemberCheck["provision_all"]) {
            $(".pro_caution").attr("style", "display:inline");
            JoinMember.confirmed_eula = "N";
            return;
        } else {
            JoinMember.confirmed_eula = "Y";
        }

        if (Common.isEmpty($realName.val())) {
            alert("이름을 입력해 주세요.");
            $realName.focus();
            return false;
        }

        if (Common.isEmpty($userId.val())) {
            alert("아이디를 입력해 주세요.");
            $userId.focus();
            return false;
        }
        if (!JoinMemberCheck.check_id) {
            alert("아이디 중복체크를 하셔야합니다.");
            $userId.focus();
            return;
        }
        if (Common.isEmpty($userEmail.val())) {
            alert("이메일을 입력해 주세요.");
            $userEmail.focus();
            return false;
        }
        if (JoinMemberCheck.check_email === false) {
            alert("사용할 수 없는 이메일입니다.");
            $userEmail.focus();
            return;
        }
        if (
            Common.isEmpty($password.val()) ||
            Common.isEmpty($passwordConfirm.val())
        ) {
            alert("비밀번호를 입력해 주세요.");
            $password.focus();
            return false;
        }

        if (!JoinMemberCheck.check_pw) {
            alert("비밀번호를 바르게 입력해 주세요.");
            $password.focus();
            return false;
        }
        if (!JoinMemberCheck.check_pw_confirm) {
            alert("비밀번호를 동일하게 입력해 주세요.");
            $passwordConfirm.focus();
            return false;
        }
        return true;
    };

    function checkJoinInput(data, $alertTarget) {
        $alertTarget.text("잠시 기다려 주십시오.");
        $alertTarget.show();
        $.ajax("//www.waglebagle.net/member/_proc/join_check.php", {
            type: "POST",
            data: data
        }).then(res => {
            $alertTarget.hide();
            var result = JSON.parse(res);

            if (result.success === false) {
                JoinMemberCheck[data.mode] = false;
            } else {
                JoinMemberCheck[data.mode] = true;
            }

            if (result.message !== null) {
                $alertTarget.text(result.message);
                $alertTarget.show();
                setTimeout(function() {
                    $alertTarget.fadeOut();
                }, 2000);
            }
        });
    };

    function init() {
        $userEmail.on("blur", e => {
            checkJoinInput(
                {
                    mode: "check_email",
                    user_email: e.currentTarget.value
                },
                $("#img_email")
            );
        });
        $idCheckBtn.on("click", e => {
            checkJoinInput(
                {
                    mode: "check_id",
                    user_id: $("#user_id").val()
                },
                $("#img_user_id")
            );
        });
        $password.on("blur", e => {
            checkJoinInput(
                {
                    mode: "check_pw",
                    password: $("#password").val(),
                    password_confirm: $("#password_confirm").val()
                },
                $("#img_password")
            );
        });
        $passwordConfirm.on("blur", e => {
            checkJoinInput(
                {
                    mode: "check_pw_confirm",
                    password: $("#password").val(),
                    password_confirm: $("#password_confirm").val()
                },
                $("#img_password_confirm")
            );
        });

        $joinBtn.on("click", e => {
            e.preventDefault();
            if (submitCheck()) {
                JoinMember.user_id = $userId.val();
                JoinMember.user_email = $userEmail.val();
                JoinMember.password = $password.val();
                JoinMember.realname = $realName.val();

                $.ajax("/member/proc_join_1.htm", {
                    type: "POST",
                    data: JoinMember
                }).then(res => {
                    res = JSON.parse(res);
                    if (res["success"]) {
                        location.replace(res["redirect_url"]);
                    } else {
                        alert(res["message"]);
                    }
                });
            }
        });
    };

    return { init };
})();

$(document).ready(function() {
    const joinMode = changeJoinMode();

    addProvisionCheckEvt();

    if (joinMode === "wagle") {
        JoinProvision.init();
    } else if (joinMode === "sns") {
        SnsJoinProc.init();
    } else {
        console.log("초기화 오류");
    }
});



// WEBPACK FOOTER //
// ./member/js/join_provision.js